@if (selectedTariffs?.length) {
  <mwe-headline headlineNodeType="h2" [headlineLevelIncrement]="0" cssClass="mb-3">
    {{ 'tariff.yourTariffDetails' | translate }}
  </mwe-headline>
  <mwe-tariff-selection-container
    [selectedTariffs]="selectedTariffs"
    [isReadOnly]="true"
    class="d-block mb-4"
    [cardCategoryTitleKeyPrefix]="cardCategoryTitleKeyPrefix"
    [hideAdditionalOptions]="isSecureOffer"
    headlineReference="h3"
    [allesSicherTextParams]="allesSicherTextParams"
  />
} @else {
  @for (product of products; track product) {
    <div class="col-12 col-lg-6 mb-4">
      <mwe-basic-card>
        <mwe-wizard-product-card
          [product]="product"
          [showTariffDetailsLink]="showTariffDetailsLink"
          [showTariffDetails]="showTariffDetails"
          [isAvailable]="true"
          [tariffClasses]="product.tariffClasses"
          [tarifKey]="product.tarifKey"
          [productSelection]="productSelection"
          [grundpreisLabelOverwrite]="grundpreisLabelOverwrite"
          [attr.data-test]="'products-summary-card-' + product.category?.toLowerCase()"
        />
      </mwe-basic-card>
    </div>
  }
}
